import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';
import {User} from '../../_models/index';
import {MatDialog,} from '@angular/material/dialog';
import {LoginHelper} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {FormBuilder} from "@angular/forms";
import {AssessmentService} from "../../_services/assessment.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {saveAs as importedSaveAs} from "file-saver";

@Component({
    standalone: false,
  selector: "assessmentUserAnswers-component",
  templateUrl: 'assessmentUserAnswers.component.html',
  styleUrls: ['./assessmentUserAnswers.component.scss'],
})

export class AssessmentUserAnswersComponent implements OnInit {
  api = window.location.origin;
  items: any[];
  assessmentId: number = null;
  assessments = [];
  quiz: any;
  tenantName: string;
  versions: any[];
  columns: any[] = [
    {field: "controlItem.complianceAreaControlId", header: "Control ID"},
  ];
  token = LoginHelper.getFileToken();
  users: User[];

  constructor(
    public route: ActivatedRoute,
    public dialogRef: MatDialogRef<AssessmentUserAnswersComponent>,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _formBuilder: FormBuilder,
    public assessmentService: AssessmentService) {
    this.quiz = data.quiz;
    this.versions = data.answers;
    this.assessmentId = data.assessmentId
  }


  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
      const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

      this.userService.getAllShort().subscribe(t => {
        this.users = t;
      })
  }

  getFullName(userId)
  {
      const user = this.users.find(u => u.userId == userId);
      if (!user) return "";
    if (user.firstName != null
      || user.lastName != null){
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  exportAnswers(){
    this.assessmentService.exportAnswers(this.assessmentId, 0, null, null, null).subscribe(blob => {
        importedSaveAs(new Blob([blob], {type: 'application/ms-excel'}), 'Answers.xlsx');
      },
      error => {
          const errorMessage = 'An error occurred while downloading results.';
          this.alertService.error(errorMessage);
      });

  }

  protected readonly encodeURIComponent = encodeURIComponent;
}
